const Vue = require('vue')
/**
 * @param {string} url
 * @returns {Object}
 */
function param2Obj(url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
  if (!search) {
    return {}
  }
  const obj = {}
  const searchArr = search.split('&')
  searchArr.forEach(v => {
    const index = v.indexOf('=')
    if (index !== -1) {
      const name = v.substring(0, index)
      const val = v.substring(index + 1, v.length)
      obj[name] = val
    }
  })
  return obj
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

/* eslint-disable */
function getUrlKey(name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
}

function dateFormat(data) {
  var date = new Date(data)
  var YY = date.getFullYear() + '-'
  var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
  var h = ' ' + (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours())
  var m = ':' + (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes())
  var s = ':' + (date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds())
  return YY + MM + DD + ' 00:00:00'
}

function dateFormat2(data) {
  var date = new Date(data)
  var YY = date.getFullYear() + '-'
  var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
  var h = ' ' + (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours())
  var m = ':' + (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes())
  var s = ':' + (date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds())
  return YY + MM + DD + h + m + s
}


function dateFormatToMax(data) {
  var date = new Date(data)
  var YY = date.getFullYear() + '-'
  var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
  return YY + MM + DD + ' 23:59:59'
}
function dateFormat3(data) {
  var date = new Date(data)
  var YY = date.getFullYear() + '-'
  var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
  return YY + MM + DD
}
function dateFormat4(data) {
  var date = new Date(data)
  var YY = date.getFullYear() + '-'
  var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
  return YY + MM
}

function dateFormat5(data) {
  var date = new Date(data)
  var YY = date.getFullYear() + '-'
  var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
  var h = ' ' + (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours())
  var m = ':' + (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes())
  return YY + MM + DD + h + m
}

function getHourAndMin(date) {
  var date = new Date(date)
  var h = ' ' + (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours())
  var m = ':' + (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes())
  var s = ':' + (date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds())
  return  h + m
}
function localTimeFormat1() {
  var date = new Date()
  var YY = date.getFullYear() + '-'
  var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
  var h = ' ' + (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours())
  return YY + MM + DD + h + ':00:00'
}
// 根据后端返回id，获取级联选择器 cascader 的路径 级联多选
function getFathersById(id, data, prop) {
  var arrRes = []
  const rev = (data, nodeId) => {
    for (var i = 0, length = data.length; i < length; i++) {
      const node = data[i]
      if (node[prop] === nodeId) {
        arrRes.unshift(node[prop])
        return true
      } else {
        if (node.children && node.children.length) {
          if (rev(node.children, nodeId)) {
            arrRes.unshift(node[prop])
            return true
          }
        }
      }
    }
    return false
  }
  rev(data, id)
  return arrRes
}

// 根据后端返回id，获取级联选择器 cascader 的路径 级联单选
function getFathersById2(id, data, prop) {
  var arrRes = []
  const rev = (data, nodeId) => {
    for (var i = 0, length = data.length; i < length; i++) {
      const node = data[i]
      if (node[prop] === nodeId) {
        arrRes.unshift(node[prop])
        return true
      } else {
        if (node.children && node.children.length) {
          if (rev(node.children, nodeId)) {
            arrRes.unshift(node[prop])
            return true
          }
        }
      }
    }
    return false
  }
  rev(data, id)
  return arrRes
}

// 获取 2层 级联子项的id串
function getCascadeSubIds(list) {
  let ids = ''
  list.forEach(res => {
    ids += res[1] + ','
  })
  return ids.substring(0, ids.length - 1)
}
// 获取 3层 级联子项的id串
function getCascadeSubIds2(list) {
  let ids = ''
  list.forEach(res => {
    ids += res[2] + ','
  })
  return ids.substring(0, ids.length - 1).replaceAll('undefined', '')
}

// 根据tree 节点数据 获取tree 顺序的一级 list
function getListFromTree(node) {
  const tempList = []
  const getNestedId = (node) => {
    if (node != null) {
      for (let i = 0; i < node.length; i++) {
        tempList.push({id: node[i].id, label: node[i].label, level: node[i].level} )
        if (node[i].children != null) {
          getNestedId(node[i].children)
        }
      }
    }
  }
  getNestedId(node)
  return tempList
}
// 根据生日计算年龄
function getAgeFromBirthDay(birthday) {
  const age = 0
  const birthDate = new Date(birthday)
  const localDate = new Date()
  return localDate.getFullYear() - birthDate.getFullYear()
}

//将数字（整数）转为汉字，从零到一亿亿，需要小数的可自行截取小数点后面的数字直接替换对应arr1的读法就行了
function convertToChinaNum(num) {
  var arr1 = new Array('零', '一', '二', '三', '四', '五', '六', '七', '八', '九');
  var arr2 = new Array('', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千','万', '十', '百', '千','亿');//可继续追加更高位转换值
  if(!num || isNaN(num)){
      return "零";
  }
  var english = num.toString().split("")
  var result = "";
  for (var i = 0; i < english.length; i++) {
      var des_i = english.length - 1 - i;//倒序排列设值
      result = arr2[i] + result;
      var arr1_index = english[des_i];
      result = arr1[arr1_index] + result;
  }
  //将【零千、零百】换成【零】 【十零】换成【十】
  result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十');
  //合并中间多个零为一个零
  result = result.replace(/零+/g, '零');
  //将【零亿】换成【亿】【零万】换成【万】
  result = result.replace(/零亿/g, '亿').replace(/零万/g, '万');
  //将【亿万】换成【亿】
  result = result.replace(/亿万/g, '亿');
  //移除末尾的零
  result = result.replace(/零+$/, '')
  //将【零一十】换成【零十】
  //result = result.replace(/零一十/g, '零十');//貌似正规读法是零一十
  //将【一十】换成【十】
  result = result.replace(/^一十/g, '十');
  return result;
}

function isNotNull(data) {
  return data !==null && data !== undefined && data !== '' && (data instanceof Array ? data.length > 0 : true)
}

function isEmpty(data) {
  return !isNotNull(data)
}

function isExcel(file) {
  return /\.(xlsx|xls|csv)$/.test(file.name)
}

function initXHeight() {
  return getClientHeight() * 0.7 + 'px'
}

function getBase64(file) {
  return new Promise(function (resolve, reject) {
    const reader = new FileReader()
    let imgResult = ''
    reader.readAsDataURL(file)
    reader.onload = function () {
      imgResult = reader.result
    }
    reader.onerror = function (error) {
      reject(error)
    }
    reader.onloadend = function () {
      resolve(imgResult)
    }
  })
}

/**
 * map转对象
 * @param strMap
 * @returns {null}
 */
function strMapToObj(strMap) {
  let obj = Object.create(null)
  for (let [k,v] of strMap) {
    obj[k] = v
  }
  return obj
}

/**
 * 把秒转换为时分秒的数组,(不补零)
 * @param {} result
 * @returns
 */
function secondToDateNoZero(result) {
  var h =  Math.floor(result / 3600);
  var m = Math.floor((result / 60 % 60));
  var s =Math.floor((result % 60));
  return [h,m,s];
}
/**
 * 获取时间格式为 HH:mm:ss
 * @param {} data
 * @returns
 */
function getHourAndMinAndSecond(data){
  var date = new Date(data)
var HH = ' ' + (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours())
var mm = ':' + (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes())
var ss = ':' + (date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds())
return HH + mm + ss;
}

/**
 * 获取浏览器可视区域高度
 */
function getClientHeight() {
  return document.documentElement.clientHeight;
}

function perXHeight(x) {
  return getClientHeight() * x + 'px'
}



// 获取 底层联子项的id串
function getCascadeEndSubIds(list) {
  let ids = ''
  list.forEach(res => {
    ids += res[res.length - 1] + ','
  })
  return ids.substring(0, ids.length - 1).replaceAll('undefined', '')
}

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
function handleTree(data, id, parentId, children) {
  let config = {
    id: id || 'id',
    parentId: parentId || 'parentId',
    childrenList: children || 'children'
  };

  var childrenListMap = {};
  var nodeIds = {};
  var tree = [];

  for (let d of data) {
    let parentId = d[config.parentId];
    if (childrenListMap[parentId] == null) {
      childrenListMap[parentId] = [];
    }
    nodeIds[d[config.id]] = d;
    childrenListMap[parentId].push(d);
  }

  for (let d of data) {
    let parentId = d[config.parentId];
    if (nodeIds[parentId] == null) {
      tree.push(d);
    }
  }

  for (let t of tree) {
    adaptToChildrenList(t);
  }

  function adaptToChildrenList(o) {
    if (childrenListMap[o[config.id]] !== null) {
      o[config.childrenList] = childrenListMap[o[config.id]];
    }
    if (o[config.childrenList]) {
      for (let c of o[config.childrenList]) {
        adaptToChildrenList(c);
      }
    }
  }
  return tree;
}

module.exports = {
  param2Obj,
  deepClone,
  getUrlKey,
  dateFormat,
  dateFormat2,
  dateFormat3,
  dateFormat4,
  localTimeFormat1,
  dateFormatToMax,
  getFathersById,
  getFathersById2,
  getListFromTree,
  getCascadeSubIds,
  getCascadeSubIds2,
  getAgeFromBirthDay,
  convertToChinaNum,
  getHourAndMin,
  isNotNull,
  strMapToObj,
  secondToDateNoZero,
  getHourAndMinAndSecond,
  isExcel,
  getClientHeight,
  isEmpty,
  dateFormat5,
  getCascadeEndSubIds,
  handleTree,
  initXHeight,
  getBase64,
  perXHeight
}
